export default __webpack_public_path__ + "media/images/front/municipality_collaboration/tohoku/ogp-4c5308bae2736f108a5a80ac0e3e4817.png";